var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-intro u-container"},[_c('div',{staticClass:"home-intro__content"},[_c('h1',[_c('strong',[_vm._v(_vm._s(_vm.userName))]),_vm._v("님"),_c('br'),_vm._v(" 안녕하세요! ")]),_c('div',{staticClass:"logo-icon",style:('background: url(' + _vm.LogoIcon + ') no-repeat center / contain;')})])])
}
var staticRenderFns = []

export { render, staticRenderFns }